module.exports = __webpack_public_path__ + "static/media/appointmentBlack.f773ab4a.svg";